module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }